<template>
  <div>
    <FullCalendar :options="state.calendarOptions" ref="calendarRef" />
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import { reactive, onMounted, ref, inject } from 'vue'
import { useStore } from 'vuex'
import planosTreinoRepository from '../../../../services/api/planosTreinoRepository'
import { useI18n } from 'vue-i18n' // Certifique-se de usar o useI18n

export default {
  name: 'calendar-card',
  components: {
    FullCalendar,
  },
  setup(props, { emit }) {
    const swal = inject('$swal')
    const { t } = useI18n() // Use o useI18n para obter o t
    const store = useStore()

    onMounted(() => {
      buscaDiasTreino()
    })

    const calendarRef = ref(null)

    const state = reactive({
      date: new Date(),
      dataSelecionada: '',
      calendarOptions: {
        locale: ptBrLocale,
        contentHeight: 'auto',
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        weekends: true,
        headerToolbar: {
          start: 'title',
          center: '',
          end: 'today prev,next',
        },
        views: {
          month: {
            titleFormat: {
              month: 'long',
              year: 'numeric',
            },
          },
        },
        events: [],
        dateClick: function (event) {
          const currentView = calendarRef.value.getApi()

          if (state.dataSelecionada) {
            currentView.el.querySelectorAll('.fc-day').forEach((day) => {
              const dateStr = day.getAttribute('data-date')
              if (dateStr === state.dataSelecionada) {
                day.style.backgroundColor = ''
              }
            })
          }
          event.dayEl.style.backgroundColor = '#344767'
          state.dataSelecionada = event.dateStr

          if (state.calendarOptions.events.find((item) => item.date === state.dataSelecionada)) {
            handleDateClick(event.dateStr)
          }
        },
      },
    })

    const handleDateClick = (date) => {
      emit('selecionaDiaTreino', date)
    }

    function buscaDiasTreino() {
      store.commit('SET_SPLASH_SCREEN', true)
      const hoje = new Date().toISOString().split('T')[0] // Data de hoje no formato YYYY-MM-DD

      planosTreinoRepository
        .DiasDeTreinoPlanoAtualGet()
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            response.data.data.forEach((obj) => {
              // Ignorar dias sem exercícios (training_type = 'none') que estão como 'not_executed' ou 'scheduled'
              // Esses dias não devem aparecer no calendário
              if (obj.training_type === 'none' && ['not_executed', 'scheduled'].includes(obj.status)) {
                return // Pular este dia
              }

              // Também ignorar dias sem exercícios que não têm status especial definido
              if (obj.training_type === 'none' && !['executed', 'incomplete', 'vacation', 'excess'].includes(obj.status)) {
                return // Pular este dia
              }

              // Verificar se a data do treino é futura ou hoje
              const isFutureOrToday = obj.training_date >= hoje

              // Definir cor baseada no status
              let backgroundColor = '#9e9e9e' // Cinza (previsto/agendado) - padrão para treinos futuros

              if (obj.status === 'executed') {
                backgroundColor = '#28a745' // Verde (executado)
              } else if (obj.status === 'incomplete') {
                backgroundColor = '#ffeb3b' // Amarelo (incompleto)
              } else if (obj.status === 'vacation') {
                backgroundColor = '#ff9800' // Laranja (férias)
              } else if (obj.status === 'excess') {
                backgroundColor = '#2196f3' // Azul (excedente)
              } else if (obj.status === 'scheduled' || isFutureOrToday) {
                // Treino previsto (futuro ou hoje sem status definido)
                backgroundColor = '#a855f7' // Roxo (previsto)
              } else {
                // Treino não executado (data passou e não foi feito)
                backgroundColor = '#dc3545' // Vermelho (não executado)
              }

              let item = {
                date: obj.training_date,
                display: 'background',
                backgroundColor: backgroundColor
              }
              state.calendarOptions.events.push(item)
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)

          // Se o erro for 406, significa que o aluno não foi selecionado
          if (error.response && error.response.status === 406) {
            swal({
              icon: 'warning',
              title: 'SELECIONE UM ALUNO PRIMEIRO',
              text: 'Por favor, selecione um aluno antes de acessar a área do aluno.',
            })
          } else {
            swal({
              icon: 'error',
              title: t('errorFetchingTrainingDays'),
              text: error.message,
            })
          }
        })
    }

    return {
      state,
      calendarRef,
      t, // Certifique-se de retornar o t
    }
  },
}
</script>

<style>
/* Dia de hoje: apenas borda, interior branco */
.fc-day-today {
  background-color: #ffffff !important;
  border: 3px solid #2196f3 !important;
}

/* Garantir que o número do dia de hoje fique visível */
.fc-day-today .fc-daygrid-day-number {
  color: #2196f3 !important;
  font-weight: bold !important;
}
</style>